<template>
  <page-skeleton>
    <template slot="header-left">
      <span :class="['header-tabs', {active: active === 1}]" @click="() => handleHeaderTabs(1)">库存表</span>
      <!-- （暂时不做🚩） -->
      <!-- <span :class="['header-tabs', {active: active === 2}]" @click="() => handleHeaderTabs(2)">库存归属</span> -->
      <span :class="['header-tabs', {active: active === 3}]" @click="() => handleHeaderTabs(3)">仓库映射表</span>
    </template>

    <template slot="container">
      <div class="operation">
        <div v-show="active === 1" class="operation-article">
          <div>
            <el-input v-model="stockParameter.skuCodes" placeholder="输入SKU（英文逗号隔开）" size="medium" suffix-icon="el-icon-search" clearable style="width: 260px;" @change="getStockList" />
            <el-select v-model="stockParameter.countryCodes" size="medium" placeholder="请选择国家" class="default-margin" style="width: 260px;" clearable multiple collapse-tags @change="getStockList">
              <el-option v-for="item in countryList" :key="item.countryCode" :label="item.countryNameCn" :value="item.countryCode" />
            </el-select>
            <el-select v-model="stockParameter.warehouseCodes" size="medium" placeholder="请选择仓库" class="default-margin" style="width: 260px;" clearable multiple collapse-tags @change="getStockList">
              <el-option v-for="item in mappingData" :key="item.warehouseId" :label="item.warehouseName" :value="item.warehouseCode" />
            </el-select>
          </div>
          <el-button type="primary" size="medium" round @click="exportStockTable">导出库存表</el-button>
        </div>
        <!-- （暂时不做🚩） -->
        <!-- <div v-show="active === 2">
          库存归属
        </div> -->
        <div v-show="active === 3" />
      </div>

      <div class="table-body">
        <!-- 库存表 -->
        <el-table v-show="active === 1" :data="stockData" height="100%" style="width: 100%">
          <el-table-column label="图片">
            <template slot-scope="{row}">
              <el-popover placement="right" width="280" trigger="hover">
                <el-image :src="row.imgUrl" fit="cover" />
                <el-image slot="reference" :src="row.imgUrl" fit="cover" class="stock-img" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="skuCode" label="SKU" />
          <el-table-column label="国家">
            <template slot-scope="{row}">
              {{`${row.countryCn}：${row.countryCode}`}}
            </template>
          </el-table-column>
          <el-table-column prop="warehouseName" label="仓库">
            <template slot-scope="{row}">
              {{`${row.warehouseName}：${row.warehouseCode}`}}
            </template>
          </el-table-column>
          <el-table-column prop="realStock" label="实际库存" />
          <el-table-column prop="stock" label="虚拟库存" />
        </el-table>

        <template slot="footer-right">
          <el-pagination background :current-page="stockParameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="stockParameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </template>
        <!-- 库存归属（暂时不做🚩） -->
        <!-- <el-table v-show="active === 2" :data="ascriptionData" height="100%" style="width: 100%">
        <el-table-column prop="test1" label="SPU" />
        <el-table-column prop="test2" label="图片/产品名称/SKU" />
        <el-table-column prop="test3" label="用户ID" />
        <el-table-column prop="test4" label="仓库" />
        <el-table-column prop="test5" label="可用库存" />
        <el-table-column prop="test6" label="在途库存" />
        <el-table-column prop="test7" label="在库库存" />
      </el-table> -->

        <!-- 仓库映射表 -->
        <el-table v-show="active === 3" :data="mappingData" height="100%" style="width: 100%">
          <el-table-column prop="warehouseNameExt" label="平台仓库名" />
          <el-table-column label="国家">
            <template slot-scope="{row}">
              {{`${row.countryCn}：${row.countryCode}`}}
            </template>
          </el-table-column>
          <el-table-column prop="warehouseId" label="原仓库ID" />
          <el-table-column prop="warehouseNameExt" label="原仓库名" />
          <el-table-column prop="warehouseTypeName" label="原仓库类型" />
        </el-table>

        <template>
          <div class="rightBtn" :style="{ 'text-align': 'right' }">
            <el-pagination background :current-page="warehouseMappingParameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="warehouseMappingParameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </template>
      </div>
    </template>

    
  </page-skeleton>
</template>
<script>
import API from '@/api'
import PageSkeleton from './components/PageSkeleton.vue'

export default {
  name: 'supply_stock',
  components: {
    'page-skeleton': PageSkeleton
  },
  data() {
    return {
      active: 1, // 头部tabs当前选中项

      countryList: [], // 国家下拉框数据源

      // 库存请求参数
      stockParameter: {
        skuCodes: undefined, // sku集合
        countryCodes: [], // 国家编码集合
        warehouseCodes: [], // 仓库编码集合
        pageNumber: 1,
        pageSize: 20
      },

      // 仓库映射请求参数
      warehouseMappingParameter: {
        pageNumber: 1,
        pageSize: 20
      },

      stockData: [], // 库存表-表格数据源

      // ascriptionData: [{
      //   test1: 'SPU',
      //   test2: '图片/产品名称/SKU',
      //   test3: '用户ID',
      //   test4: '仓库',
      //   test5: '可用库存',
      //   test6: '在途库存',
      //   test7: '在库库存'
      // }], // 库存归属-表格数据源（暂时不做🚩）

      mappingData: [], // 库存归属-仓库映射表

      total: 0, // 分页总条数
      currentPage: 1
    }
  },
  created() {
    this.getStorageParams()
    this.getCountryList()
    this.getStockList(false)
    this.getWarehouseMappingList(false)
  },
  methods: {
    // 库存
    async getStockList(call = true) {
      try {
        if (call) this.resetStockPage()
        let newStockParameter = { ...this.stockParameter }
        if (newStockParameter.skuCodes) {
          newStockParameter.skuCodes = newStockParameter.skuCodes.split(',')
        } else {
          newStockParameter.skuCodes = undefined
        }
        newStockParameter.countryCodes = newStockParameter.countryCodes.length ? newStockParameter.countryCodes : undefined
        newStockParameter.warehouseCodes = newStockParameter.warehouseCodes.length ? newStockParameter.warehouseCodes : undefined
        this.$store.commit('setState', {key: 'stockGetListParams', value: {...this.stockParameter, active: this.active} })
        let { data } = await API.getStockList(newStockParameter)
        this.stockData = data.list
        this.total = data.total
      } catch (error) {
        throw new Error(error.message)
      }
      this.$tableScrollTop()
    },
    resetStockPage() {
      this.stockParameter.pageNumber = 1
    },

    // 仓库映射
    async getWarehouseMappingList(call = true) {
      try {
        if (call) this.resetWarehouseMappingPage()
        let { data } = await API.getWarehouseMappingList(this.warehouseMappingParameter)
        this.mappingData = data.list
        this.total = data.total
      } catch (error) {
        throw new Error(error.message)
      }
      this.$tableScrollTop()
    },
    resetWarehouseMappingPage() {
      this.warehouseMappingParameter.pageNumber = 1
    },

    // 获取国家列表
    async getCountryList() {
      let { data } = await API.getCountryList()
      this.countryList = data
    },

    // tabs点击的回调
    handleHeaderTabs(key) {
      this.active = key
      this.currentPage = 1
      switch (this.active) {
        case 1: // 库存表
          this.getStockList()
          break
        case 2: // 库存归属（暂时不做🚩）
          break
        case 3: // 仓库映射表
          this.getWarehouseMappingList()
          break
      }
    },

    // 导出库存表
    exportStockTable() {
      let form
      if (this.active === 1) {
        form = {
          skuCodes: this.stockParameter.skuCodes,
          countryCodes: this.stockParameter.countryCodes,
          warehouseCodes: this.stockParameter.warehouseCodes,
          pageNumber: this.stockParameter.pageNumber,
          pageSize: this.stockParameter.pageSize
        }
      }
      API.importExportFile({ fileType: 2, taskType: 1, condition: JSON.stringify(form) }).then(() => {
        this.$message.success('用户数据导出成功,请前往导入导出中心查看进度')
      })
    },

    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      switch (this.active) {
        case 1:
          this.stockParameter.pageSize = size
          this.getStockList(false)
          break
        case 2:

          break
        case 3:
          this.warehouseMappingParameter.pageSize = size
          this.getWarehouseMappingList(false)
          break
      }
    },

    // 上一页/下一页/当前页发生改变时的回调
    handleCurrentChange(current) {
      switch (this.active) {
        case 1:
          this.stockParameter.pageNumber = current
          this.getStockList(false)
          break
        case 2:

          break
        case 3:
          this.warehouseMappingParameter.pageNumber = current
          this.getWarehouseMappingList(false)
          break
      }
    },
    getStorageParams() {
      const { active, ...other } = this.$store.state.stockGetListParams
      this.active = active
      if(active === 1) this.stockParameter = Object.assign(this.stockParameter, other)
      else if(active === 3)this.warehouseMappingParameter = Object.assign(this.warehouseMappingParameter, other)
      // 视图绑定的页码
      const { pageNumber } = other
      this.currentPage = pageNumber
    }
  }
}
</script>

<style lang="scss" scoped>
.header-tabs {
  display: inline-block;
  color: #cdd4dd;
  height: 30px;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  padding: 0 28px;
  user-select: none;
  cursor: pointer;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  &:hover {
    background-color: #f5f7f7;
  }
}

.operation {
  margin-bottom: 12px;
  .operation-article {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.default-margin {
  margin-left: 15px;
}

.table-body {
  height: calc(100% - 36px - 12px);
}

.active {
  color: #fff;
  background-color: #99c41c !important;
}

.stock-img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #f5f7fa;
  user-select: none;
  cursor: pointer;
}
</style>